import React, { useCallback, useEffect, useState } from 'react'
import { acknowledgeAlert, fetchAlerts } from '../api/dashboard'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import { AlertsTable } from '../components/dashboard'

const Alerts = ({ setIsAuthenticated, userEmail, userRole, onLogout }) => {
  const [isSidebarVisible, setSidebarVisible] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 1024;
    }
    return true;
  });
  const [alerts, setAlerts] = useState([]);
  const [alertsLoading, setAlertsLoading] = useState(false);
  const [acknowledgeLoading, setAcknowledgeLoading] = useState(false);
  const [alertsPage, setAlertsPage] = useState(1);
  const [alertsPageSize, setAlertsPageSize] = useState(20);
  const [alertsTotalPages, setAlertsTotalPages] = useState(1);
  const [alertsTotalCount, setAlertsTotalCount] = useState(0);

  const toggleSidebar = () => setSidebarVisible((prev) => !prev);

  const loadAlerts = useCallback(async () => {
    setAlertsLoading(true);
    try {
      const alertsResponse = await fetchAlerts();
      const list = Array.isArray(alertsResponse) ? alertsResponse : [];
      const total = list.length;
      const startIndex = Math.max(0, (alertsPage - 1) * alertsPageSize);
      const endIndex = startIndex + alertsPageSize;
      setAlerts(list.slice(startIndex, endIndex));
      setAlertsTotalCount(total);
      setAlertsTotalPages(Math.max(1, Math.ceil(total / alertsPageSize)));
    } catch (error) {
      setAlerts([]);
      setAlertsTotalCount(0);
      setAlertsTotalPages(1);
    } finally {
      setAlertsLoading(false);
    }
  }, [alertsPage, alertsPageSize]);

  useEffect(() => {
    setAlertsPage(1);
  }, [alertsPageSize]);

  useEffect(() => {
    loadAlerts();
    const interval = setInterval(loadAlerts, 60000);
    return () => clearInterval(interval);
  }, [loadAlerts]);

  const handleAcknowledge = useCallback(async (fingerprint, options = {}) => {
    setAcknowledgeLoading(true);
    try {
      await acknowledgeAlert(fingerprint, options);
      // Перезагружаем список алертов после подтверждения
      await loadAlerts();
    } catch (error) {
      throw error;
    } finally {
      setAcknowledgeLoading(false);
    }
  }, [loadAlerts]);

  return (
    <div className="relative flex min-h-screen flex-col overflow-clip bg-surface-base text-muted-100">
      <div className="pointer-events-none absolute inset-0 -z-10 bg-brand-radial opacity-50" />
      <Header isSidebarVisible={isSidebarVisible} toggleSidebar={toggleSidebar} userEmail={userEmail} userRole={userRole} />
      <div className="flex flex-1">
        <Sidebar 
          onLogout={onLogout} 
          userRole={userRole} 
          isSidebarVisible={isSidebarVisible}
          onClose={() => setSidebarVisible(false)}
        />
        <main className="flex min-w-0 flex-1 flex-col bg-surface-base/60 px-3 py-4 sm:px-4 sm:py-6 lg:px-10">
          <div>
            <AlertsTable
              alerts={alerts}
              isLoading={alertsLoading}
              onAcknowledge={handleAcknowledge}
              acknowledgeLoading={acknowledgeLoading}
              page={alertsPage}
              totalPages={alertsTotalPages}
              pageSize={alertsPageSize}
              totalCount={alertsTotalCount}
              onPageChange={setAlertsPage}
              onChangePageSize={setAlertsPageSize}
            />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Alerts;

